import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { DetailsValue } from '@/components/molecules/DetailsValue';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly label: string;
  readonly value: string | React.ReactElement;

  readonly labelDecoration?: string;
}

export const LabeledDetail: React.FC<Props> = (props: Props): React.ReactElement => {
  const { label, labelDecoration, value } = props;

  const tr = useTranslator();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box>
        <Typography component="span" variant="body2" color="text.primary">
          {tr(label)}
        </Typography>
        {labelDecoration ? (
          <Typography component="span" variant="body2" color="custom.LightGray">
            {' '}
            {labelDecoration}
          </Typography>
        ) : null}
      </Box>
      <DetailsValue>{value}</DetailsValue>
    </Box>
  );
};
